// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".manager__avatar img[data-v-0e1d162c]{max-width:180px}.social-msg img[data-v-0e1d162c]{max-width:28px}", ""]);
// Exports
module.exports = exports;
